import { ExcelLikeGrid } from "../../../shared/excel-grid/components/ExcelLikeGrid";
import type { AdminKpisGridSectionProps } from "../../models/admin-kpis.models";
import { memo } from "react";

const AdminKpisGridSection = ({
  title,
  countLabel,
  rows,
  columns,
  dataTest,
  emptyLabel,
  gridHeightClassName,
  emptySectionMessage,
  virtualized = false,
  virtualizedMaxHeight,
  useContentColumnWidths = true,
}: AdminKpisGridSectionProps) => {
  return (
    <section
      data-test={`${dataTest}-section`}
      className={gridHeightClassName ? "flex min-w-0 flex-col" : "flex min-h-[420px] min-w-0 flex-col"}
    >
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-xl font-semibold">{title}</h2>
        <span className="text-sm font-medium text-[#4A5655] dark:text-gray-300">{countLabel}</span>
      </div>
      {emptySectionMessage && rows.length === 0 ? (
        <div className="border border-[#D7E2DE] bg-white px-4 py-6 text-sm text-[#4A5655] shadow-sm dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
          {emptySectionMessage}
        </div>
      ) : (
        <div className={gridHeightClassName ? "min-h-0" : "flex min-h-0 flex-1"}>
          <ExcelLikeGrid
            rows={rows}
            columns={columns}
            dataTest={dataTest}
            emptyLabel={emptyLabel}
            onCellCommit={() => undefined}
            rowHeight={34}
            showHeadersWhenEmpty={true}
            className={gridHeightClassName}
            virtualized={virtualized}
            virtualizedMaxHeight={virtualizedMaxHeight}
            useContentColumnWidths={useContentColumnWidths}
          />
        </div>
      )}
    </section>
  );
};

export default memo(AdminKpisGridSection);
